interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <span className="inline-flex items-center gap-2 font-label text-xs uppercase tracking-[0.2em] text-primary-600">
        <span className="h-px w-6 bg-primary-400"></span>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}